export default function force() {
    return fetch("https://us-central1-autodial-dfeb8.cloudfunctions.net/cron");
}
